import translations from '../../translations';

export default function (calculationTotal) {
    if (calculationTotal) {
        const currencyHtml = ' <span class="val">' + $('#Currency').val() + '</span>';

        let promocodeDiscount = convertPriceByCurrency(calculationTotal.Discount);
        let totalPrice = convertPriceByCurrency(calculationTotal.TotalWithDiscount + calculationTotal.Discount);

        let totalWithDiscount = totalPrice - promocodeDiscount;

        $('.js-total-price').html(toString(totalPrice) + currencyHtml);
        $('.js-promocode-discount-price').html(toString(promocodeDiscount) + currencyHtml);
        $('.js-to-pay-value').html(toString(totalWithDiscount) + currencyHtml);

        let discount = calculationTotal.Discount / currency.rate;

        let customerSavings = parseFloat(document.querySelector('.js-customer-savings').innerText.replace(',', '.'));
        customerSavings = (customerSavings ? customerSavings : 0) + discount;
        customerSavings = customerSavings % 1 == 0 ? customerSavings.toFixed(0) : customerSavings.toFixed(2)

        $('.js-customer-savings').html(customerSavings.replace('.', ',') + currencyHtml);

        if (customerSavings > 0)
            $('.js-customer-savings').closest('tr').show();
        else
            $('.js-customer-savings').closest('tr').hide();

        let totalLabel = translations.promocodeTotal[getCurrentLanguage()];
        $('.js-total-title').text(totalLabel);
    }

    function convertPriceByCurrency(price) {
        let result = (price / currency.rate) * currency.coefficient;
        result = result % 1 == 0 ? result.toFixed(0) : result.toFixed(2); 

        return parseFloat(result);
    }

    function toString(value) {
        
        return value.toString().replace('.', ',');
    }

    function getCurrentLanguage() {
        var siteLanguage = ''

        switch (window.location.pathname.split('/')[1]) {
            case 'ru':
                siteLanguage = 'ru';
                break;
            case 'en':
                siteLanguage = "en"
                break;
            case 'pl':
                siteLanguage = "pl"
                break;
            case 'es':
                siteLanguage = "es"
                break;

            default:
                siteLanguage = "uk";
                break;
        }

        return siteLanguage;
    }
}